import { getLocale } from "../runtime";

const sv_productimagealt = /** @type {(inputs: {productName: NonNullable<unknown>, brandName: NonNullable<unknown>}) => string} */ (inputs) => {
	return `${inputs.productName} - ${inputs.brandName}`
};

const productimagealt = /** @type {(inputs: {productName: NonNullable<unknown>, brandName: NonNullable<unknown>}, options?: {locale?: string}) => string} */ (inputs = {}, options = {}) => {
	const locale = options.locale ?? getLocale();
	if (locale === "sv") return sv_productimagealt(inputs)
	return "productImageAlt";
};

export { productimagealt as "productImageAlt" };